import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "finform";
import { Url } from "finhelper";

import { CenteredWrapper, Container } from "#app/pages/styles";
import { Img, ImgContainer, NotFoundContainer, Text, Title } from "./styles";
import swan from "./images/swan.svg";

interface UnexpectedErrorState {
    statuses: unknown[];
}

class UnexpectedError extends Component<Record<string, never>, UnexpectedErrorState> {
    constructor(props: Record<string, never>) {
        super(props);
        this.state = {
            statuses: [],
        };
    }

    render() {
        const url = Url.getCurrentUrl();

        return (
            <Container style={{ margin: "20px auto 0 auto" }}>
                <CenteredWrapper>
                    <NotFoundContainer>
                        <ImgContainer>
                            <Img src={swan} alt="" />
                        </ImgContainer>
                        <Title>Ошибка</Title>
                        <Text>Сообщите нам об ошибке info@blackswan.finance</Text>
                        <Text />
                        <Button
                            className="style1"
                            type="href"
                            href={url.indexOf("/cabinet") !== -1 ? "/cabinet" : "/"}
                        >
                            На главную
                        </Button>
                    </NotFoundContainer>
                </CenteredWrapper>
            </Container>
        );
    }
}

const enhance = connect(() => ({}), {});

export default enhance(UnexpectedError);
